import { ENV } from '.';

export const PAYMENT_TYPE = {
  SFPLUS: 'SF Plus',
  CREDIT_CARD: 'Credit Card',
  THAI_QR: 'Thai QR'
};

export const BANK_INVOICE =
  ENV === 'production' ? 3 : ENV === 'staging' ? 2 : 1;
